import { createContext } from 'react'
import { TOMORROW } from '../../utils/helper'

export const initData = {
    room: {
        num: 0,
        maxPerson: 1
    },
    billing: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        address: '',
        firm: '',
        tax: ''
    },
    date: {
        startDate: TOMORROW,
        endDate: TOMORROW,
        key: 'selection'
    },
    personCount: {
        adults: 1,
        children: []
    },
    note: '',
    gdpr: false
}

export const initLoading = {
    isLoading: false,
    text: ''
}

const ReservationContext = createContext({
    loading: initLoading,
    reservationData: initData,
    reservedDates: [],
    moneyChange: false,
    manualReservation: false,
    resetData: () => { },
    setRoom: () => { },
    setBilling: () => { },
    setDate: () => { },
    setPersonCount: () => { },
    setNote: () => { },
    setGdpr: () => { },
    setLoading: () => { },
    setMoneyChange: () => { },
    setManualReservation: () => { }
})

export default ReservationContext
